<template>
  <b-modal
    id="modal-pallet"
    @show="$v.$reset()"
    title="Ingresar detalles"
    size="lg"
    hide-footer="true"
  >
    <b-row>
      <b-col lg="6">
        <b-jumbotron>
          <template slot="header">
            <p>{{ calculateGross }}</p>
          </template>

          <template slot="lead">
            <p>{{ socketWeight }} Kg Brutos</p>
            <p class="font-weight-bold font-2xl">{{ netWeight }} Kg Netos</p>
          </template>
          <p v-if="!connected" class="text-danger">
            * Conexión con báscula no establecida
          </p>
        </b-jumbotron>
      </b-col>
      <b-col lg="6">
        <b-form-group>
          <label class="font-weight-bold" for="name">Cantidad</label>
          <b-form-input
            type="text"
            autocomplete="off"
            v-model="$v.form.quantity.$model"
            :state="$v.form.quantity.$dirty ? !$v.form.quantity.$error : null"
            v-on:keyup="inputSoloNumero"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group v-if="selected.container.id != 'BIN'">
          <label class="font-weight-bold" for="name">Peso Pallet</label>
          <b-form-input
            v-model="$v.form.pallet_weight.$model"
            :state="
              $v.form.pallet_weight.$dirty
                ? !$v.form.pallet_weight.$error
                : null
            "
            type="text"
            autocomplete="off"
            v-on:keyup="inputSoloNumeroDecimal"
            id="name"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group>
          <label class="font-weight-bold" for="name">Peso Bruto</label>
          <b-form-input
            v-model="$v.form.gross_weight.$model"
            :state="
              $v.form.gross_weight.$dirty ? !$v.form.gross_weight.$error : null
            "
            type="text"
            autocomplete="off"
            v-on:keyup="inputSoloNumeroDecimal"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group>
          <label class="font-weight-bold" for="name">Peso Neto</label>
          <b-form-input disabled :value="netWeight" type="text"> </b-form-input>
        </b-form-group>

        <!-- <template v-slot:modal-footer> -->
        <div class="w-100">
          <b-button
            variant="primary"
            @click.prevent="onSubmit"
            class="float-right ml-1"
            >Guardar<!-- /imprimir -->
          </b-button>
          <!-- <b-button class="float-right ml-1" variant="primary">Guardar</b-button> -->
          <b-button
            class="float-right ml-1"
            @click="$bvModal.hide('modal-pallet')"
            >Cancelar</b-button
          >
        </div>
        <!-- </template> -->
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { decimal, integer, required } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import searchSelect from "../../searchSelect";

export default {
  name: "SetPallet",
  props: ["selected"],
  components: {
    searchSelect
  },
  mounted() {
    this.form.quantity = this.selected.quantity;
  },
  data() {
    return {
      form: {
        quantity: 0,
        pallet_weight: 0,
        gross_weight: null
      },
      submitStatus: false
    };
  },
  watch: {
    socketWeight(newValue, oldValue) {
      this.form.gross_weight = newValue;
    }
  },
  computed: {
    ...mapState("socketModule", ["socketWeight", "connected"]),
    ...mapState("bagnoArrivalModule", ["containers"]),
    netWeight() {
      return (
        this.form.gross_weight -
        this.form.pallet_weight -
        this.form.quantity * this.selected.material_weight
      );
    }
  },
  methods: {
    getContainers() {},
    resetForm() {
      this.form.quantity = null;
      this.form.pallet_weight = 0;
      this.form.gross_weight = null;
    },
    updateRow() {
      const data = {
        id: this.selected.idx,
        quantity: parseInt(this.form.quantity),
        gross_weight: this.form.gross_weight,
        container: this.selected.container,
        netWeight: this.netWeight
      };
      this.$store.dispatch("bagnoArrivalModule/updateRow", data);
    },
    onSubmit(evt) {
      this.$v.form.$touch();
      this.submitStatus = true;
      if (this.$v.$invalid) {
        evt.preventDefault();
        this.$toast.info("Campos restantes en el formulario", "");
      } else {
        if (this.netWeight >= 0) {
          this.updateRow();
          this.resetForm();
          this.$nextTick(() => {
            this.$bvModal.hide("modal-pallet");
          });
        } else {
          this.$toast.info("El campo peso neto no puede ser negativo", "");
        }
      }
    },
    inputSoloNumero(event) {
      event.target.value = event.target.value.replace(/[^0-9]/, "");
    },
    inputSoloNumeroDecimal(event) {
      event.target.value = event.target.value.replace(/[^0-9.]/, "");
    }
  },
  validations: {
    form: {
      quantity: { required, integer },
      pallet_weight: { required },
      gross_weight: { required }
    }
  }
};
</script>

<style>
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  min-height: calc(1.5em + 0.75rem + 2px);
  font-size: 0.6875rem;
  font-weight: 400;
  color: #5c6873;
  border: none;
  margin-top: -7px;
  margin-left: -10px;
}
.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #394066;
}
</style>
